module.exports = __webpack_public_path__ + "img/example_logo_color.8378057d.png";